import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { QuotationRequestService } from '@app/_services/quotation-request.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { TranslateHelper } from '@app/_helpers';
import { AuthenticationService, QuotationCartService } from '@app/_services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Pagination } from '@app/_interfaces/pagination.interface';
import { Subject } from 'rxjs';
import { ceil } from 'lodash';
import { debounceTime, switchMap, switchMapTo } from 'rxjs/operators';
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component';
import { NgFor, NgIf, DatePipe } from '@angular/common';
@Component({
    selector: 'app-page-generic-quotation-list',
    templateUrl: './page-generic-quotation-list.component.html',
    styleUrls: ['./page-generic-quotation-list.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, NgIf, PaginationComponent, DatePipe, TranslateModule]
})
export class PageGenericQuotationListComponent implements OnInit {

    userDetails;
    items: any;
    constructor(private authService: AuthenticationService, public quotationRequestService: QuotationRequestService,
        private toastr: ToastrService, public translate: TranslateService,
        public translateHelper: TranslateHelper, private router: Router, private route: ActivatedRoute,
        ) {}

        requests;
        paginationOrderCount;
        pagination: Pagination = {
            page: 1,
            limit: 10
        }
        paginationSubject$: Subject<any> = new Subject();
        ngOnInit() {
             this.quotationRequestService.getAll(this.pagination).subscribe((response) => {
                this.requests = response['data'];
                this.paginationOrderCount = ceil(response['ordersCount'] / 10)
            });

            this.paginationSubject$.pipe(
                debounceTime(1000),
                switchMap(() => {
                    return this.quotationRequestService.getAll(this.pagination);
                })
            ).subscribe(response => {
                this.requests = response['data'];
            });
        }

        updateOrdersList(pageNumber) {
            this.pagination.page = pageNumber;
            this.paginationSubject$.next();
        }

        updateUrl() {
            this.router.navigate(
                [],
                {
                    relativeTo: this.route,
                    queryParams: this.pagination,
                    queryParamsHandling: '',
                });
        }

        status = {
            new: {
                color: '#125077',
                text: 'New',
            },
            open: {
                color: '#9E6DEB',
                text: 'Open',
            },
            offered: {
                color: '#ff5900',
                text: 'Offered',
            },
            accepted: {
                color: '#079008',
                text: 'Accepted',
            },
            inprogress: {
                color: '#6D9EEB',
                text: 'In-Progress',
            },
            rejected: {
                color: '#ff0202',
                text: 'Rejected',
            },

            cancelled: {
                color: '#ff0202',
                text: 'Cancelled',
            },
            renegotiated: {
                color: '#0095a0',
                text: 'Renegotiated',
            },
        };

        orderDetails(request){this.router.navigate(['/account/quotation-requests/' , request._id])}

}
